export const AUTHORIZATION_CODE_STORAGE_KEY = 'AuthCode';
export const ANONYMOUS_TOKEN_STORAGE_KEY = 'PublicToken';
export const USER_TOKEN_STORAGE_KEY = 'AuthToken';
export const ID_TOKEN_STORAGE_KEY = 'AuthIdToken';
export const AUTH_REDIRECT_URL_STORAGE_KEY = 'AuthRedirectUrl';
export const AUTH_REDIRECT_URI_STORAGE_KEY = 'AuthRedirectUri';
export const CODE_VERIFIER_STORAGE_KEY = 'AuthCodeVerifier';
export const AUTH_STATE_STORAGE_KEY = 'AuthState';
export const NONCE_STORAGE_KEY = 'AuthNonce';

/** User ID for user that is not logged in */
export const NOT_LOGGED_IN_USER_ID = -1;
//# sourceMappingURL=constants.js.map